import React from "react";

type ResultButtonProps = {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export function ResultButton({ children, onClick }: ResultButtonProps) {
  return (
    <button
      className="mt-3 w-full rounded-md border-2 border-rdc-primary bg-none p-2 text-rdc-primary transition-all hover:bg-inherit hover:font-bold"
      onClick={onClick}
    >
      {children}
    </button>
  );
}
